import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"icon-close\">\n    <g fill=\"currentColor\" fill-rule=\"evenodd\">\n        <path d=\"M1.929 0l12.7278 12.728-1.4142 1.4142L.5147 1.4142z\" />\n        <path d=\"M12.728 0L0 12.728l1.4142 1.4142 12.728-12.728z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol